import { Box, Flex, Text } from '@chakra-ui/react';
import {
  CheckTypeMap,
  EResultStatus,
  ICheckResult
} from '@publishing-engine/domain/models';
import { openFile } from 'src/utils/file';
import CheckTitle from './CheckTitle';
import IntegrityStatusIcon from './IntegrityStatusIcon';
import { MailToLink } from '../MailToLink';

openFile;
type IProps = {
  check: ICheckResult;
  showUrl?: boolean; // used for alignment and manage report URL
  roundId: string;
  submissionId: string;
  submissionContextId: string;
  currentState: string;
};
const ErrorView: React.FC<{ check: ICheckResult }> = ({ check }) => {
  return (
    <>
      <Flex align="start" gap={2} paddingLeft={4}>
        <Box marginTop={1}>
          {<IntegrityStatusIcon severity={'BROWN' as EResultStatus} />}
        </Box>
        <Box>
          <Text lineHeight={'initial'} textStyle={'headingItem'}>
            {check.result?.title}
          </Text>
          <Text textStyle={'textContext'}>
            {check.result?.subtitle}
            {check.result?.hasMailTo && ` For help, contact `}
            {check.result?.hasMailTo && <MailToLink></MailToLink>}
          </Text>
        </Box>
      </Flex>
    </>
  );
};
const Checks = ({
  check,
  showUrl,
  roundId,
  submissionId,
  submissionContextId,
  currentState
}: IProps) => {
  if (check.result?.status === 'BROWN') {
    return <ErrorView check={check} />;
  }
  return (
    <Box
      key={check?.externalId + roundId}
      width={'full'}
      paddingLeft={showUrl ? 4 : 0}
      marginBottom={1}
    >
      <Flex justifyContent={'space-between'} alignItems={'center'}>
        <CheckTitle
          title={
            check?.result?.title
              ? check?.result?.title
              : CheckTypeMap[check.checkType]
          }
          checkStatus={check?.result?.status || check.status}
          subtitle={check.result?.subtitle}
          showUrl={check.result?.showDetailedReport && showUrl}
          submissionId={submissionId}
          checkType={check.checkType}
          runId={check.runId}
          currentState={currentState}
          submissionContextId={submissionContextId}
        />
      </Flex>
    </Box>
  );
};

export default Checks;
